// noinspection JSDeprecatedSymbols

(function ($) {

	let initAlignments = function () {
		const body = document.querySelector('body');
		const scrollbar = window.innerWidth - body.clientWidth;
		body.setAttribute("style", `--scrollbar: ${scrollbar}px`);
	};

	let initNav = function () {
		let primaryNav = $('#siteHeader__navigation');
		let siteSearch = $('#siteHeader__search');

		$('button, .siteHeader__toggleSearch', '#siteHeader').on('click', function (e) {
			e.preventDefault();
			let isOpen = $(this).attr('aria-expanded');
			let targetID = $(this).attr('aria-controls');
			let target;

			if (targetID === 'siteHeader__navigation') {
				target = 'siteHeader__navigation';
			} else {
				target = $('#' + targetID);
			}

			if (isOpen === 'true') {
				if (target === 'siteHeader__navigation') {
					$([primaryNav]).each(function () {
						$(this).hide()
					});
				} else {
					target.hide();
				}

				$(this).attr('aria-expanded', 'false').removeClass('is-active');
			} else {
				$('.siteHeader__button').not(this).attr('aria-expanded', 'false').removeClass('is-active');
				$([primaryNav, siteSearch]).each(function () {
					$(this).hide()
				});

				if (target === 'siteHeader__navigation') {
					$([primaryNav]).each(function () {
						$(this).show()
					});
				} else {
					target.show();
				}

				$(this).attr('aria-expanded', 'true').addClass('is-active');

				if (targetID === 'siteHeader__search') {
					$('input[type="search"], input[type="text"]', siteSearch).focus();
				}
			}
		});

		$('#searchform').on('submit', function (e) {
			let query = $(this).find('#s').val();

			if (!query.trim()) {
				e.preventDefault();

				$(this).find('input').eq(0).focus();
			}
		});

		$('details', '#primaryNav').on('toggle', function (e) {
			let details = e.currentTarget;
			let isOpening = details.open;
			let isDesktop = window.matchMedia('(min-width: 65rem)').matches;

			if (isDesktop) {
				if (isOpening) {
					$('details', '#primaryNav').not(this).removeAttr('open');
				}
			}
		});

	};

	let initFacets = function () {

		let isTabletOrAbove = window.matchMedia('(min-width: 47.5rem)').matches;

		if (!isTabletOrAbove) {
			$('#filters').removeAttr('open');
		}

		let excludedFacets = [
			'result_count',
			'load_more'
		]

		let openFacets = [
			'opening_type',
			'content_type'
		]

		$(document).on('facetwp-loaded', function () {
			$('.filters__facet--accordion .facetwp-facet').each(function () {
				let $facet = $(this);
				let facet_name = $facet.attr('data-name');
				let facet_label = FWP.settings.labels[facet_name];

				if (!excludedFacets.includes(facet_name)) {
					if (!($facet).is(':empty')) {
						if ($facet.closest('.facet-wrap').length < 1 && $facet.closest('.facetwp-flyout').length < 1) {
							let open = openFacets.includes(facet_name);
							$facet.wrap('<details class="facet-wrap  accordion__item"' + (open ? ' open' : '') + '></details>');
							$facet.before('<summary class="facet-label  accordion__title"><span class="accordion__toggle"> ' + facet_label + '</span></summary>');
						}
					}
				}
			});

			$('.filters__facet--label .facetwp-facet, .filters__facet--inline .facetwp-facet').each(function () {
				let $facet = $(this);
				let facet_name = $facet.attr('data-name');
				let facet_label = FWP.settings.labels[facet_name];

				if (!excludedFacets.includes(facet_name)) {
					if (!($facet).is(':empty')) {
						if ($facet.closest('.facet-wrap').length < 1 && $facet.closest('.facetwp-flyout').length < 1) {
							$facet.wrap('<div class="facet-wrap"></div>');
							$facet.before('<span class="facet-label"> ' + facet_label + '</span>');
						}
					}
				}
			});

			$('.filters__facet--label-hidden .facetwp-facet').each(function () {
				let $facet = $(this);
				let facet_name = $facet.attr('data-name');
				let facet_label = FWP.settings.labels[facet_name];

				if (!excludedFacets.includes(facet_name)) {
					if (!($facet).is(':empty')) {
						if ($facet.closest('.facet-wrap').length < 1 && $facet.closest('.facetwp-flyout').length < 1) {
							$facet.wrap('<div class="facet-wrap"></div>');
							$facet.before('<span class="facet-label  visually-hidden"> ' + facet_label + '</span>');
						}
					}
				}
			});

			let facetCounts = $('.facetwp-counts');

			if (facetCounts.length) {
				let topOfFilteredResults = (facetCounts.offset().top - window.innerHeight / 10);
				let scrollPos = window.pageYOffset;

				if (scrollPos > 1) {
					if (topOfFilteredResults > scrollPos + window.innerHeight / 1.5 || topOfFilteredResults < scrollPos - window.innerHeight / 10) {
						$('html, body').stop().animate({
							scrollTop: topOfFilteredResults
						}, 250);
					}
				}
			}
		});

	};

	let initSliders = function () {
		window.addEventListener('load', function () {
			$('.clientHighlights__glider').each(function () {
				new Glider(this, {
					duration: 0.2,
					scrollLock: true,
					// scrollLockDelay: 50,
					// draggable: true,
					// dragVelocity: 1.5,
					dots: '#clientHighlights__gliderDots',
					arrows: {
						prev: '.clientHighlights__gliderPrev',
						next: '.clientHighlights__gliderNext'
					}
				});
			});

			$('.slider__glider').each(function () {
				new Glider(this, {
					duration: 0.2,
					scrollLock: true,
					// scrollLockDelay: 50,
					// draggable: true,
					// dragVelocity: 1.5,
					dots: '#slider__gliderDots',
					arrows: {
						prev: '.slider__gliderPrev',
						next: '.slider__gliderNext'
					}
				});
			});

			$('.accolades__glider').each(function () {
				new Glider(this, {
					duration: 0.2,
					// scrollLock: true,
					slidesToShow: 'auto',
					slidesToScroll: 'auto',
					itemWidth: 235,
					// scrollLockDelay: 50,
					// draggable: true,
					// dragVelocity: 1.5,
					arrows: {
						prev: '.accolades__gliderPrev',
						next: '.accolades__gliderNext'
					}
				});
			});
		});

		document.addEventListener('glider-loaded', hideFFScrollBars);
		document.addEventListener('glider-refresh', hideFFScrollBars);

		function hideFFScrollBars(e) {
			var scrollbarHeight = 17; // Currently 17, may change with updates
			if (/firefox/i.test(navigator.userAgent)) {
				// We only need to appy to desktop. Firefox for mobile uses
				// a different rendering engine (WebKit)
				if (window.innerWidth > 575) {
					e.target.parentNode.style.height = (e.target.offsetHeight - scrollbarHeight) + 'px'
				}
			}
		}
	};

	let initPathfinder = function () {
		$('.pathfinder').each(function () {
				let pathfinder = $(this);

				$('input[name="aud"], input[name="prc"], input[name="dpt"]', pathfinder).on('change', function () {
					let practiceID = $(this).attr('data-practice-id');
					let audienceID = $(this).attr('data-audience-id');

					if (audienceID) {
						$('.pathfinder__officeInput', pathfinder).each(function () {
							$(this).prop('checked', false);
							let audiences = $(this).attr('data-audiences').split(',');

							if (audiences.includes(audienceID)) {
								$(this).attr('disabled', false);
							} else {
								$(this).attr('disabled', true);
							}
						});
					} else if (practiceID) {
						$('.pathfinder__officeInput', pathfinder).each(function () {
							$(this).prop('checked', false);
							let practices = $(this).attr('data-practices').split(',');

							if (practices.includes(practiceID)) {
								$(this).attr('disabled', false);
							} else {
								$(this).attr('disabled', true);
							}
						});
					} else {
						$('.pathfinder__officeInput', pathfinder).each(function () {
							$(this).prop('disabled', false);
							$(this).prop('checked', false);
						});
					}
				});

				// resets to subsequent steps on change

				$('input[name="aud"]', pathfinder).on('change', function () {
					updateSelectedClasses($(this));

					$('input[name="dpt"], input[name="prc"], input[name="ofc"]', pathfinder).each(function () {
						$(this).prop('checked', false);
						updateSelectedClasses($(this));
					});

					let val = $(this).val();
					let nextStep = '';

					switch (val) {
						case 'professional-staff':
							nextStep = 'departments';
							break;

						case 'law-students-recent-graduates':
						case 'experienced-attorneys':
							nextStep = 'practices';
							break;

						case 'patent-agents':
							nextStep = 'offices';
							break;

						default:
							nextStep = 'submit';
					}

					$(this).parents('.pathfinder__step').attr('data-next-step', nextStep);
				});

				$('input[name="dpt"]', pathfinder).on('change', function () {
					$('input[name="prc"], input[name="ofc"]', pathfinder).each(function () {
						$(this).prop('checked', false);
						updateSelectedClasses($(this));
					});
				});

				$('input[name="prc"]', pathfinder).on('change', function () {
					$('input[name="dpt"], input[name="ofc"]', pathfinder).each(function () {
						$(this).prop('checked', false);
						updateSelectedClasses($(this));
					});
				});

				$('input[name="ofc"]', pathfinder).on('change', function () {
					// show next step only
				});

				let updateSelectedClasses = function (el) {
					let val = el.val();

					el.parents('.pathfinder__step').find('.is-selected').each(function () {
						$(this).removeClass('is-selected').parents('.has-child-selected, .pathfinder__fieldSet').removeClass('has-child-selected');
					});

					if (val && val !== 'all') {
						el.parents('.pathfinder__step').addClass('pathfinder__step--complete');
						el.parent('.pathfinder__fieldItem').addClass('is-selected').parents('.pathfinder__fieldItem.has-children, .pathfinder__fieldSet').addClass('has-child-selected');
					} else {
						el.parents('.pathfinder__step').removeClass('pathfinder__step--complete').parents('.has-child-selected').removeClass('has-child-selected');
					}

					if (el.is(':checked')) {
						let section = el.parents('.pathfinder__step');
						scrollToSection(section);
					}
				};

				let scrollToSection = function (section) {

					if (section) {
						let topOfElement = (section.offset().top - window.innerHeight / 10);
						let scrollPos = window.pageYOffset;

						if (topOfElement > scrollPos + window.innerHeight / 1.5 || topOfElement < scrollPos - window.innerHeight / 20) {
							$('html, body').stop().animate({
								scrollTop: topOfElement
							}, 250);
						}
					}
				};

				$('input[name="aud"]:checked, input[name="dpt"]:checked, input[name="prc"]:checked, input[name="ofc"]:checked', pathfinder).each(function () {
					updateSelectedClasses($(this));
				});

				$('input[name="aud"], input[name="dpt"], input[name="prc"], input[name="ofc"]', pathfinder).each(function () {
					$(this).on('change', function () {
						updateSelectedClasses($(this));
					});
				});
			}
		)
		;
	};

	let initSelectize = function () {
		$('.alumniFinder__school').selectize();
	};

// --

	$(document).ready(function () {
		initAlignments();
		initNav();
		initFacets();
		initSliders();
		initPathfinder();
		initSelectize();
	});

	$(window).on('load', function () {
		// correct anything loaded on DOM load which might need adjusting (mostly once images have loaded)
	});


// $(window).smartResize(function () {
//   // events that need to fire after a window resize (or device rotation)
//   Waypoint.refreshAll();
// });

})
(jQuery);
